import isEmpty from "lodash-es/isEmpty"
import map from "lodash-es/map"

import type {
    ISelfDiagnosticBaseDto as ISelfAssessmentBaseDto,
    ISelfDiagnosticBaseModel as ISelfAssessmentBaseModel,
    ISelfDiagnosticQuestionBaseDto as ISelfAssessmentQuestionDto,
    ISelfDiagnosticQuestionBaseModel as ISelfAssessmentQuestionModel,
    ISelfDiagnosticQuestionOptionDto as ISelfAssessmentQuestionOptionDto,
    ISelfDiagnosticQuestionOptionModel as ISelfAssessmentQuestionOptionModel,
    ISelfDiagnosticSummaryBaseDto as ISelfAssessmentSummaryDto,
    ISelfDiagnosticSummaryBaseModel as ISelfAssessmentSummaryModel,
    ISelfDiagnosticAnswerBaseDto,
    ISelfDiagnosticAnswerBaseModel
} from "@/3514/types"

function selfAssessmentSummaryAdapter({
    rank_from: rankFrom,
    rank_to: rankTo,
    short_summary: shortSummary,
    summary
}: ISelfAssessmentSummaryDto): ISelfAssessmentSummaryModel {
    return {
        rankFrom,
        rankTo,
        shortSummary,
        summary
    }
}

function selfAssessmentQuestionAdapter(dto: ISelfAssessmentQuestionDto): ISelfAssessmentQuestionModel {
    return {
        isActive: dto.is_active,
        isNotApplicable: dto.not_applicable,
        notApplicableLabel: dto.not_applicable_label,
        optionsCount: dto.option_numbers,
        order: dto.order,
        question: dto.question,
        uuid: dto.uuid,
        options: isEmpty(dto.options)
            ? []
            : map<ISelfAssessmentQuestionOptionDto, ISelfAssessmentQuestionOptionModel>(
                  dto.options,
                  ({
                      allow_free_response: isFreeResponseAllowed,
                      free_response_prompt: freeResponsePrompt,
                      response,
                      uuid
                  }: ISelfAssessmentQuestionOptionDto): ISelfAssessmentQuestionOptionModel => ({
                      isFreeResponseAllowed,
                      freeResponsePrompt,
                      response,
                      uuid
                  })
              )
    }
}

function selfAssessmentBaseAdapter(dto: ISelfAssessmentBaseDto): ISelfAssessmentBaseModel {
    return isEmpty(dto)
        ? null
        : {
              questionList: isEmpty(dto.question_list)
                  ? []
                  : map<ISelfAssessmentQuestionDto, ISelfAssessmentQuestionModel>(
                        dto.question_list,
                        selfAssessmentQuestionAdapter
                    ),
              summaryList: isEmpty(dto.summary_list)
                  ? []
                  : map<ISelfAssessmentSummaryDto, ISelfAssessmentSummaryModel>(
                        dto.summary_list,
                        selfAssessmentSummaryAdapter
                    ),
              type: dto.type
          }
}

function selfAssessmentAnswerBaseAdapter(dto: ISelfDiagnosticAnswerBaseDto): ISelfDiagnosticAnswerBaseModel {
    return { answer: dto.answer, questionUuid: dto.question_uuid, optionUuid: dto.option_uuid }
}

export {
    selfAssessmentBaseAdapter,
    selfAssessmentSummaryAdapter,
    selfAssessmentQuestionAdapter,
    selfAssessmentAnswerBaseAdapter
}
